// ENUM TRACKING EVENTS NAMES

export enum ETrackingEventsName {
    API_REQUEST = 'api-request',
    SCREEN_VIEW = 'screen-view',
    USER_INTERACTION = 'user-interaction',
}

// INTERFACES TRACKING EVENTS
export interface ITRackingScreen {
    type: 'SCREEN_VIEW';
    data: ITrackingScreenData;
}

export interface ITRackingRequest {
    type: 'API_REQUEST';
    data: ITrackingRequestData;
}
export interface ITRackingUserInteraction {
    type: 'USER_INTERACTION';
    data: ITrackingUserInteraction;
}

// INTERFACES TRACKING EVENTS DATA
export interface ITrackingRequestData {
    screenName: string;
    endpointUrl: string;
    method: string;
    result: string;
    httpStatus: string;
    errorCode?: string;
}
export interface ITrackingScreenData {
    screenName: string;
}
export interface ITrackingUserInteraction {
    screenName: string;
    id: string;
}

// UNION TRACKING EVENTS
type UnionTrackingEvents = ITRackingScreen | ITRackingRequest | ITrackingUserInteraction;
export type UnionTrackingEventsData = ITrackingRequestData | ITrackingScreenData | ITrackingUserInteraction;

// INTERFACES TRACKING GLOBAL

export interface ITrackingEvent {
    type: 'TRACKING';
    data: UnionTrackingEvents;
}

export type IStepperTimeLineOrders = {
    date: string;
    time: string;
    description: string;
};
